import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material'
import { useTerminology } from '../../../../utils/useTerminology'

type ConfirmDeleteWorkflowDialogProps = {
	name: string
	onConfirm: () => void
	onCancel: () => void
}

export const ConfirmDeleteWorkflowDialog = (
	props: ConfirmDeleteWorkflowDialogProps,
) => {
	const { workflow } = useTerminology()

	return (
		<>
			<DialogTitle>Confirm Delete {workflow.singular}</DialogTitle>
			<DialogContent>
				<Typography>
					Are you sure that you want to remove the <b>{props.name}</b>{' '}
					{workflow.singular}?
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button color="primary" onClick={props.onCancel}>
					Cancel
				</Button>
				<Button color="primary" variant="contained" onClick={props.onConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</>
	)
}
